var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60004 4.36401C4.94318 4.36401 3.60004 5.70716 3.60004 7.36401V16.6367C3.60004 18.2936 4.94318 19.6367 6.60004 19.6367H17.4C19.0569 19.6367 20.4 18.2936 20.4 16.6367V7.36401C20.4 5.70716 19.0569 4.36401 17.4 4.36401H6.60004ZM12.6257 5.89155C11.5212 5.89155 10.6257 6.78698 10.6257 7.89155V16.1097C10.6257 17.2143 11.5212 18.1097 12.6257 18.1097H16.7203C17.8248 18.1097 18.7203 17.2143 18.7203 16.1097V7.89155C18.7203 6.78698 17.8248 5.89155 16.7203 5.89155H12.6257Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.615fcc587426f3c40f38da4fe2adffcd.svg";
export { ForwardRef as ReactComponent };